module.exports = __webpack_public_path__ + "static/img/ff0f578a65274931d8073ef4c9476a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MODE2-off.png
// module id = JTU9
// module chunks = 1